export default "__VITE_ASSET__BeGXRdWL__"